module.exports = __webpack_public_path__ + "images/25d26d850169a33cfc8e4f2b17046989.png";